import { EmendaResumida } from "@/types/entregas/emendas/emenda-resumida";
import { Service } from "../mainService";
import { PortalError } from "@/types/portal-error";
import { Emenda } from "@/types/entregas/emendas/emenda";
import { RetornoListaEmendas } from "@/types/entregas/emendas/retorno-lista-emendas";

const emendaService = {
    getEmendas,
    removeEmenda,
    getEmendaById,
    getTiposEmenda,
    saveEmenda,
    baixarAnexoEmenda,
}

async function getEmendas(currentPage = 1, nrEmenda: string | null, ano: number | null, autor: number | null, tipoEmenda: number | null): Promise<RetornoListaEmendas> {
    try {
        const response = await Service.$http.get(
            `${process.env.VUE_APP_ENTREGAS_API}/Emenda/listar?page=${currentPage}&pageSize=10${nrEmenda ? `&filtroNumero=${nrEmenda}` : ''}${ano ? `&filtroAno=${ano}` : ''}${autor ? `&filtroAutor=${autor}` : ''}${tipoEmenda ? `&filtroTipo=${tipoEmenda}` : ''}`
        )
        return new RetornoListaEmendas(await response.data)
    } catch (e: any) {
        if (e.response && [400, 401, 403].includes(e.response.status)) {
            const errors: any = [];
            if (e.response.data.errors)
                for (const [key, value] of Object.entries(e.response.data.errors))
                    errors.push(`${key}: ${value}`);
            throw new PortalError(
                e.response.data.erros ?? e.response.data.msg ?? errors
            );
        } else {
            throw e;
        }
    }
}

async function removeEmenda(idEmenda: number): Promise<any> {
    try {
        const response = await Service.$http.delete(
            `${process.env.VUE_APP_ENTREGAS_API}/Emenda/remover/${idEmenda}`
        )
    } catch (e: any) {
        if (e.response && [400, 401, 403].includes(e.response.status)) {
            const errors: any = [];
            if (e.response.data.errors)
                for (const [key, value] of Object.entries(e.response.data.errors))
                    errors.push(`${key}: ${value}`);
            throw new PortalError(
                e.response.data.erros ?? e.response.data.msg ?? errors
            );
        } else {
            throw e;
        }
    }
}

async function getEmendaById(idEmenda: number): Promise<Emenda> {
    try {
        const response = await Service.$http.get(
            `${process.env.VUE_APP_ENTREGAS_API}/Emenda/detalhes/${idEmenda}`
        )
        return new Emenda(response.data)
    } catch (e: any) {
        if (e.response && [400, 401, 403].includes(e.response.status)) {
            const errors: any = [];
            if (e.response.data.errors)
                for (const [key, value] of Object.entries(e.response.data.errors))
                    errors.push(`${key}: ${value}`);
            throw new PortalError(
                e.response.data.erros ?? e.response.data.msg ?? errors
            );
        } else {
            throw e;
        }
    }
}

async function getTiposEmenda(): Promise<{ Id: number, Descricao: string }[]> {
    try {
        const response = await Service.$http.get(
            `${process.env.VUE_APP_ENTREGAS_API}/Emenda/tipos`
        )
        return response.data
    } catch (e: any) {
        if (e.response && [400, 401, 403].includes(e.response.status)) {
            const errors: any = [];
            if (e.response.data.errors)
                for (const [key, value] of Object.entries(e.response.data.errors))
                    errors.push(`${key}: ${value}`);
            throw new PortalError(
                e.response.data.erros ?? e.response.data.msg ?? errors
            );
        } else {
            throw e;
        }
    }
}

async function saveEmenda(emenda: Emenda): Promise<Emenda> {
    try {
        emenda.NrEmenda = emenda.NrEmenda.replace(/\D/g, '')
        const data = emenda.toFormData()
        if (emenda.ArquivoPlanoTrabalhoForm)
            data.set("ArquivoPlanoTrabalhoForm", emenda.ArquivoPlanoTrabalhoForm as unknown as Blob);
        if (emenda.ArquivoExtratoForm)
            data.set("ArquivoExtratoForm", emenda.ArquivoExtratoForm as unknown as Blob);
        const response = await Service.$http.post(
            `${process.env.VUE_APP_ENTREGAS_API}/Emenda/salvar`,
            data
        )
        return new Emenda(response.data)
    } catch (e: any) {
        if (e.response && [400, 401, 403].includes(e.response.status)) {
            const errors: any = [];
            if (e.response.data.errors)
                for (const [key, value] of Object.entries(e.response.data.errors))
                    errors.push(`${key}: ${value}`);
            throw new PortalError(
                e.response.data.erros ?? e.response.data.msg ?? errors
            );
        } else {
            throw e;
        }
    }
}

async function baixarAnexoEmenda(idEmenda: number, tipo: string): Promise<Blob> {
    try {
        const response = await Service.$http.get(
            `${process.env.VUE_APP_ENTREGAS_API}/Emenda/baixarAnexo/${idEmenda}?tipo=${tipo}`,
            { responseType: 'blob' }
        )
        return response.data
    } catch (e: any) {
        if (e.response && [400, 401, 403].includes(e.response.status)) {
            const errors: any = [];
            if (e.response.data.errors)
                for (const [key, value] of Object.entries(e.response.data.errors))
                    errors.push(`${key}: ${value}`);
            throw new PortalError(
                e.response.data.erros ?? e.response.data.msg ?? errors
            );
        } else {
            throw e;
        }
    }
}

export default emendaService
